import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=a7bef752&scoped=true&"
import script from "./triangle.vue?vue&type=script&lang=js&"
export * from "./triangle.vue?vue&type=script&lang=js&"
import style0 from "./triangle.vue?vue&type=style&index=0&id=a7bef752&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bef752",
  null
  
)

export default component.exports